import { useLightMode } from '@/hooks/useLightMode'

import { Box } from '@hivewatch/dark'

import { getNotificationToastTokens } from '../styles/tokens'

export const NotificationDescription = ({ desc }: { desc: string }) => {
  const tokens = getNotificationToastTokens(useLightMode())
  return (
    <Box
      color={tokens.textSecondary}
      lineClamp={2}
      mt='5px'
      textStyle='caption'
    >
      {desc}
    </Box>
  )
}
